import { IABTestsContext, TestsState } from './models';

export const INITIAL_TESTS_DATA: TestsState = {
  SkipLandingPage: {
    data: {
      isActive: false,
      isParticipant: false,
    },
    properties: {
      skipLandingPageParticipant: false,
      skipLandingPage: false,
    },
  },
};

export const INITIAL_CONTEXT_STATE: IABTestsContext = {
  data: {
    get: () => ({}),
    set: () => {},
  },
  properties: {
    get: () => ({}),
    set: () => {},
    getAllFlat: () => ({}),
  },
};
